import { render, staticRenderFns } from "./trainRecord.vue?vue&type=template&id=417c0cab&scoped=true&"
import script from "./trainRecord.vue?vue&type=script&lang=js&"
export * from "./trainRecord.vue?vue&type=script&lang=js&"
import style0 from "./trainRecord.vue?vue&type=style&index=0&id=417c0cab&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "417c0cab",
  null
  
)

export default component.exports